import type { ReactNode } from 'react'

import { AgenciesView } from './agencies.view'

export const AgenciesPage = (): ReactNode => <AgenciesView />
